<template>
  <div class='daytrips'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> -->
    <div class='row row-tours-rural' >
      <div class='column' style="margin:auto;">
        <div class='cont2'>
          <!-- <a href='/daymain' class='btn btn-light centered'><p>Through the Canyons and 2 National Parks</p></a> -->
          <a href='/ruraltour1' class='tour-link'>
            <img src='@/assets/rural/tour1/01.jpg'/>
            <div class='tour-border'>
              <p class='tour-name'>Rural Montenegro</p>
              <p class='tour-info'>From <span>1700 &euro;</span></p>
              <p class="tour-info">10 days / 9 nights</p>
            </div>
          </a>
        </div>
      </div>
    </div>
    <br/>
    <br/>
    <div id ='thumbnail-container'>
      <vue-picture-swipe :items='items' class='gallery'></vue-picture-swipe>
    </div>
    <div style='text-align:justify;width:90%; margin:auto;margin-top:50px;'>
       <!-- <h1 style='text-align: center;'>Rural tourism in Montenegro</h1> -->
        <p class='pasus'>In Montenegro, we say that if it could be flat, it would be one of the largest countries in the world, thanks to its relief and the large number of hills and high mountains. Behind all those mountains, in valleys, river canyons, on the shores of lakes, in the hinterland of the sea, there are a large number of wonderful villages, in which the most persistent and hardworking still survive in the traditional way. Some of these villages are known for their agricultural products, semi-nomadic lifestyle, some for their fishing tradition, architecture, traditional manifestations, old crafts. Very often in their vicinity there are national parks, nature parks, spectacular canyons and lakes, significant cultural heritage.</p>
        <p class='pasus'>Our wish is to bring the most authentic part of Montenegro closer to our guests, to introduce them to the traditional face of Montenegro, the products of rural areas, the lifestyle in them, to experience beautiful preserved natural areas, but also to contribute and support the local population and their great effort to improve the quality of life in remote areas with often quite difficult living conditions.</p>
        <p class='pasus'>Montenegro is one of the greenest countries in Europe with about 60% of the territory covered by forests, rich flora and fauna, clean air, quality food, favorable climate and offers many opportunities for a peaceful and pleasant stay and escape from the modern hustle and bustle.</p>
        <p class='pasus'>In the program of our tours oriented towards rural tourism, a visit to a rural household, farm, significant village, national parks or other natural areas of exceptional value and importance is scheduled every day. Accommodation can be in rural households, ethno villages or smaller hotels.</p>
        <p class='pasus'>On the example of a ten-day tour, you can familiarize yourself with the potential program in detail, which of course can be modified according to your preferences, and last as long as it suits you.</p>
        <p class='pasus'>It will be our great pleasure to introduce you to the authentic and true face of Montenegro.</p>
        <p class='pasus'>Cheers!</p>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/rural/main/1.jpg'),
          thumbnail: require('@/assets/rural/main/1.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/2.jpg'),
          thumbnail: require('@/assets/rural/main/2.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/3.jpg'),
          thumbnail: require('@/assets/rural/main/3.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/4.jpg'),
          thumbnail: require('@/assets/rural/main/4.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/5.jpg'),
          thumbnail: require('@/assets/rural/main/5.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/6.jpg'),
          thumbnail: require('@/assets/rural/main/6.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/7.jpg'),
          thumbnail: require('@/assets/rural/main/7.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/8.jpg'),
          thumbnail: require('@/assets/rural/main/8.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/9.jpg'),
          thumbnail: require('@/assets/rural/main/9.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/10.jpg'),
          thumbnail: require('@/assets/rural/main/10.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/11.jpg'),
          thumbnail: require('@/assets/rural/main/11.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/12.jpg'),
          thumbnail: require('@/assets/rural/main/12.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/13.jpg'),
          thumbnail: require('@/assets/rural/main/13.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/14.jpg'),
          thumbnail: require('@/assets/rural/main/14.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/15.jpg'),
          thumbnail: require('@/assets/rural/main/15.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/16.jpg'),
          thumbnail: require('@/assets/rural/main/16.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/17.jpg'),
          thumbnail: require('@/assets/rural/main/17.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/19.jpg'),
          thumbnail: require('@/assets/rural/main/19.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/20.jpg'),
          thumbnail: require('@/assets/rural/main/20.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/21.jpg'),
          thumbnail: require('@/assets/rural/main/21.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/22.jpg'),
          thumbnail: require('@/assets/rural/main/22.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/23.jpg'),
          thumbnail: require('@/assets/rural/main/23.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/24.jpg'),
          thumbnail: require('@/assets/rural/main/24.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/25.jpg'),
          thumbnail: require('@/assets/rural/main/25.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/26.jpg'),
          thumbnail: require('@/assets/rural/main/26.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/27.jpg'),
          thumbnail: require('@/assets/rural/main/27.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/main/28.jpg'),
          thumbnail: require('@/assets/rural/main/28.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

/* Create four equal columns that sits next to each other */
.column {
  flex: 80%;
  max-width: 80%;
  padding: 0 4px;
}
.tour-link>img{
  max-height: 500px;
}
.column img {
  margin-top: 8px;
  vertical-align: middle;
  width: 100%;
}

/* Responsive layout - makes a two column-layout instead of four columns */
@media screen and (max-width: 800px) {
  .column {
    flex: 100%;
    max-width: 100%;
  }
}

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .column {
    flex: 100%;
    max-width: 100%;
  }
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2vw;
  background-color: rgba(165, 165, 165, 0.6);
  /* opacity: 0.6; */
  border-radius: 5px;
  border: none;
  padding: 0px 20px;
  /* color: #000000; */
}
.centered:hover {
  background: rgba(173, 255, 47, 0.5);
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}

div.my-gallery {
    display: flex !important;
    flex-wrap: nowrap !important; /* Ensures thumbnails stay in a single row */
    overflow-x: auto !important; /* Enables horizontal scrolling if thumbnails overflow */
}

</style>



// WEBPACK FOOTER //
// src/components/RuralMontenegro.vue